export const UserAccess = "UserAccess";
export const TenantAccess = "TenantAccess";
export const LicenseAccess = "LicenseAccess";
export const ContentAccess = "ContentAccess";
export const EnterpriseAccess = "EnterpriseAccess";
export const ReportAccess = "ReportAccess";

export const ReadScope = "Read";
export const UpdateScope = "Update";
export const DeleteScope = "Delete";
export const CreateScope = "Create";

// Composed access scopes
export const ENTERPRISE_MANAGE = [EnterpriseAccess, UpdateScope];

// The seeded SysRoot role, the same id in every organisation.
export const SYSROOT_ROLE_ID = "fb0fcce9-55b8-4522-972a-3dbc0c3685e4";

// Whether a role id (from the API, any case) is the SysRoot role.
export const isSysRootRole = (roleId) =>
  String(roleId || "").toLowerCase() === SYSROOT_ROLE_ID;
